module.exports = __webpack_public_path__ + "../resources/images/exemplary-inbox-f25d5aade1a9696407c8bf4662fb8688.png";